import { useGetFormScheme } from './useGetFormScheme';
import { useMemo } from 'react';
import { getEnrichedSchema, IEnrichmentObject } from '../utils';
import { useSelector } from 'react-redux';
import { selectBankOptions, selectRegionOptions } from '../selectors';

/**
 * Обогащение схемы калькулятора пришедшими пропсами словарей городов и банков
 * */
export const useGetEnrichedScheme = () => {
  const formScheme = useGetFormScheme();
  const bankOptions = useSelector(selectBankOptions);
  const regionOptions = useSelector(selectRegionOptions);

  const scheme = useMemo(() => {
    const enrichmentObject: IEnrichmentObject = {
      ['payrollBank']: bankOptions,
      ['regionId']: regionOptions,
    };

    return getEnrichedSchema(formScheme.elements, enrichmentObject);
  }, [formScheme, bankOptions, regionOptions]);

  return scheme;
};
